import PageTitle from "../../components/pagetitle/PageTitle";
import Bg from "../../images/shapes/shape_title_under_line.svg";
import shape1 from "../../images/shapes/shape_space_4.svg";
import shape2 from "../../images/shapes/shape_angle_3.webp";
function Privacypolicy() {
  const bgg = {
    backgroundColor: "#F9F9F9",
    padding: "2rem",
    borderRadius: "10px",
    marginTop: "2rem",
  };

  return (
    <main className="page_content about-page">
      <PageTitle pageTitle="Terms and Conditions " />

      <section className="faq_section section_decoration pt-5">
        <div className="container">
          <div className="heading_block text-center">
            <div
              className="heading_focus_text has_underline d-inline-flex"
              style={{ backgroundImage: `url(${Bg})` }}
            >
              Terms and Conditions
            </div>
          </div>

          <p className="mt-4 lh-base text-start">
            Welcome to Ape it Solutions! These Terms and Conditions govern your
            access to and use of the software, services, and products . By using
            our Services, you agree to these Terms, as well as our Privacy
            Policy. If you do not agree to these Terms, you should not use our
            Services.
          </p>

          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Use of Services</h4>
                <p>
                  You may use our Services only for lawful purposes and in
                  accordance with these Terms. You agree not to use our
                  Services:
                </p>
                <ul className="lh-lg">
                  <li>
                    {" "}
                    In any way that violates any applicable federal, state,
                    local, or international law or regulation.
                  </li>
                  <li>
                    To transmit, or procure the sending of, any advertising or
                    promotional material, including any "junk mail," "chain
                    letter," "spam," or any other similar solicitation.
                  </li>
                  <li>
                    {" "}
                    To engage in any other conduct that restricts or inhibits
                    anyone's use or enjoyment of the Services, or which, as
                    determined by us, may harm Ape It or users of the Services
                    or expose them to liability.
                  </li>
                </ul>
                <p>
                  We may share your personal information with third-party
                  service providers who help us provide our travel solutions,
                  such as airlines, hotels, and car rental companies. We require
                  these service providers to maintain the confidentiality of
                  your information and only use it for the purposes for which we
                  have engaged them.
                </p>
              </div>
            </div>
          </div>

          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Intellectual Property</h4>
                <p className="lh-lg">
                  The Services and its entire contents, features, and
                  functionality (including but not limited to all information,
                  software, text, displays, images, video, and audio) are owned
                  by Ape It Solutions, its licensors, or other providers of such
                  material and are protected by United States and international
                  copyright, trademark, patent, trade secret, and other
                  intellectual property or proprietary rights laws.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Limitation of Liability</h4>
                <p className="lh-lg">
                  In no event shall Ape It Solutions, nor its directors,
                  employees, partners, agents, suppliers, or affiliates, be
                  liable for any indirect, incidental, special, consequential or
                  punitive damages, including without limitation, loss of
                  profits, data, use, goodwill, or other intangible losses,
                  resulting from your access to or use of or inability to access
                  or use the Services.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Indemnification</h4>
                <p className="lh-lg">
                  You agree to indemnify and hold Ape It Solutions, its
                  affiliates, licensors and service providers, and its and their
                  respective officers, directors, employees, contractors,
                  agents, licensors, suppliers, successors, and assigns harmless
                  from any claims, liabilities, damages, judgments, awards,
                  losses, costs, expenses, or fees (including reasonable
                  attorneys' fees) arising out of or relating to your violation
                  of these Terms or your use of the Services.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Termination</h4>
                <p className="lh-lg">
                  We may terminate or suspend your access to our Services
                  immediately, without prior notice or liability, for any reason
                  whatsoever, including without limitation if you breach these
                  Terms. Upon termination, your right to use the Services will
                  immediately cease.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg}>
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Changes to Terms and Conditions</h4>
                <p className="lh-lg">
                  We reserve the right, at our sole discretion, to modify or
                  replace these Terms at any time. If a revision is material, we
                  will provide notice via our website. What constitutes a
                  material change will be determined at our sole discretion.
                </p>
              </div>
            </div>
          </div>
          <div style={bgg} className="mb-4">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <h4 className="mb-3">Contact Us</h4>
                <p className="lh-lg">
                  If you have any questions about this privacy policy or our
                  practices, please contact us at info@apeitsolutions.com. By using our Services, you agree to these
                  Terms and Conditions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="decoration_item shape_image_1">
          <img src={shape1} alt=" Shape" />
        </div>
        <div className="decoration_item shape_image_2">
          <img src={shape2} alt=" Shape Angle" />
        </div>
      </section>
    </main>
  );
}

export default Privacypolicy;
